angular.module('app.core', [
  'decorators.texasDialog',
  'resources',
  'security',
  'constant',
  'orderEmpty',
  'fromNowFilter',
  'services.errorLogger',
  'services.dialogs',
  'services.priceMatrix',
  'services.matrixNode',
  'services.toaster',
  'services.helper',
  'services.loadSpinner',
  'services.saving',
  'core.init',
  'core.config',
  'directives',
  'tabs',
]);
